@if (rateLimited()) {
	<ui-notify
		[text]="'help_overlay.rate_limit_error' | translate"
		type="warning"
		data-cy="ui-help-content-rate-limit"
	></ui-notify>
}
<p>{{ 'help_overlay.body' | translate }}</p>
<div class="pt-6">
	<label
		class="form-label"
		for="textarea-help-content-description"
		data-cy="ui-help-content-description-label"
		>{{
			'help_overlay.description_label'
				| translate: { length: descriptionLength(), minLength: MIN_DESCRIPTION_LENGTH }
		}}</label
	>
	<ui-textarea
		[autofocus]="true"
		[errorText]="
			'help_overlay.description_error' | translate: { minLength: MIN_DESCRIPTION_LENGTH }
		"
		[formField]="description"
		[resizeDisabled]="true"
		[singleLine]="true"
		inputId="help-content-description"
		data-cy="ui-help-content-description"
	></ui-textarea>
</div>
<div class="flex flex-col gap-2">
	<ui-button
		[disabled]="description().invalid() || sending()"
		[fullWidth]="true"
		[showSpinner]="sending()"
		[text]="'help_overlay.submit' | translate"
		(buttonClicked)="onSubmitClick()"
		data-cy="ui-help-content-submit-button"
		class="px-1"
	></ui-button>
	<ui-button
		[fullWidth]="true"
		[text]="'general.cancel' | translate"
		type="link"
		(buttonClicked)="onCancelClick()"
		data-cy="ui-help-content-cancel-button"
		class="px-1 pb-1"
	></ui-button>
</div>
